import { FileTextOutlined } from "@ant-design/icons";
import { BodhiCard } from "@bodhistreams/ui";
import { formatCertificateDate, getSubscriberName } from "./certificateUtils";
import "./CertificatePreview.css";

const CertificatePreview = ({ values, membershipName, user }) => {
	return (
		<BodhiCard className="cert-card" title="Live Preview" hoverable={false}>
			<div className="cert-doc">
				<div className="cert-doc-head">
					<div className="cert-doc-brand">Bodhistreams</div>
					<h3 className="cert-doc-name">
						Certificate of Service and License of Use
					</h3>
					<span className="cert-doc-issued">
						Issued {formatCertificateDate(new Date().toISOString())}
					</span>
				</div>

				<div className="cert-doc-block">
					<span className="cert-doc-block-label">
						Licensed Business or Organization
					</span>
					<p className="cert-doc-business">{values.business_name}</p>
					<p className="cert-doc-address">
						{values.property_address || "Property address will appear here"}
					</p>
				</div>

				<p className="cert-doc-para">
					Bodhistreams certifies that the business or organization named above
					is authorized per an active commercial direct license agreement in
					effect with Bodhistreams to play background music in the
					above-mentioned location.
				</p>

				<div className="cert-doc-meta">
					<div className="cert-doc-meta-item">
						<span className="cert-doc-meta-label">Service Start Date</span>
						<span className="cert-doc-meta-value">
							{formatCertificateDate(values.service_start_date)}
						</span>
					</div>
					<div className="cert-doc-meta-item">
						<span className="cert-doc-meta-label">Subscription</span>
						<span className="cert-doc-meta-value">{membershipName}</span>
					</div>
				</div>

				<p className="cert-doc-para">
					Authorized contact: {values.contact_name}
					{values.contact_email ? ` (${values.contact_email})` : ""}.
					Subscription plan: {membershipName}.
				</p>

				<p className="cert-doc-para">
					Bodhistreams maintains music licensing agreements in effect with its
					music content providers and warrants that it possesses the necessary
					rights to distribute, stream, and publicly perform their music
					worldwide for in-store commercial background music service purposes.
				</p>

				<div className="cert-doc-sign">
					<FileTextOutlined className="cert-doc-sign-icon" />
					<div>
						<span className="cert-doc-sign-title">Issued by Bodhistreams</span>
						<span className="cert-doc-sign-sub">
							Account holder: {getSubscriberName(user)}
						</span>
						<span className="cert-doc-sign-sub">
							Member since: {formatCertificateDate(values.service_start_date)}
						</span>
					</div>
				</div>
			</div>
		</BodhiCard>
	);
};

export default CertificatePreview;
